// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3njh8","inputWrap":"Table_inputWrap__3dzUx","col":"Table_col__2qQD-","bmiTooltip":"Table_bmiTooltip__1EJr8"};